// Nickname rules shared by the game (instant feedback) and the leaderboard server (server/lib.ts),
// so both always agree on what's allowed. Pure: no DOM, no engine imports.

const BLOCKED = /(fuck|shit|cunt|nigg|fag|rape|hitler|nazi|kontol|memek|anjing|bangsat|ngentot|jancok|goblok|tolol)/i;
const SHAPE = /^[A-Za-z0-9 _.-]{3,16}$/;

/** Collapses runs of whitespace and trims. */
export function tidyName(v: string): string {
  return v.trim().replace(/\s+/g, ' ');
}

/** Trimmed nickname, 3-16 chars of letters, digits, space, _ . -; null when not acceptable. */
export function cleanName(v: unknown): string | null {
  if (typeof v !== 'string') return null;
  const name = tidyName(v);
  if (!SHAPE.test(name)) return null;
  if (BLOCKED.test(name.replace(/[\s_.-]/g, ''))) return null;
  return name;
}

/** Why a name is refused (for the input hint), or null when it's fine. */
export function nameProblem(v: string): string | null {
  const name = tidyName(v);
  if (!SHAPE.test(name)) return '3-16 letters, numbers, spaces, _ . or -';
  return cleanName(name) ? null : 'That name isn’t allowed. Try another.';
}

const ADJ = ['Swift', 'Lucky', 'Bold', 'Rapid', 'Steady', 'Brave', 'Sunny', 'Dusty', 'Turbo', 'Hilly', 'Rocky', 'Zippy'];
const NOUN = ['Driver', 'Courier', 'Rider', 'Climber', 'Hauler', 'Runner', 'Wheels', 'Pilot', 'Trucker', 'Racer', 'Chef', 'Rover'];

/** Random callsign like "TurboCourier27" (always valid). Pass the RNG (UI code, never the sim's PRNG). */
export function randomCallsign(rnd: () => number): string {
  const pick = <T,>(a: readonly T[]) => a[Math.floor(rnd() * a.length)];
  return `${pick(ADJ)}${pick(NOUN)}${10 + Math.floor(rnd() * 90)}`;
}
